import { render } from "./IconoConGuardar.vue?vue&type=template&id=ce702160&scoped=true"
const script = {}

import "./IconoConGuardar.vue?vue&type=style&index=0&id=ce702160&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce702160"]])

export default __exports__